<div>
  <div class="filter-container">
    <div class="row">
      <div class="col-3 date-main pl-0 mr-0 pr-0">
        <div class="date-box">
          <div class="filter-item-date" style="padding-left: 0.1%;">
            <div class="filter-item-label">{{'' | i18n: 'Date Range for Export:'}}:</div>
            <input id="toDates" [(ngModel)]="filter.exportDateFrom" type="date" name="toDate"
              (change)="refreshList()">
            </div>
          </div>
          <div class="filter-to">
            <div class="filter-item-label" style="visibility: hidden;">..</div>
            {{'' | i18n: 'to'}}
          </div>
          <div class="date-box pl-0">
            <div class="filter-item-date" style="padding-left: 0.1%;">
              <div class="filter-item-label" style="visibility: hidden;">..</div>
              <input id="toDates1" [(ngModel)]="filter.exportDateTo" type="date" name="toDate" (change)="refreshList()">
            </div>
          </div>
        </div>
        <div class="col-3 pl-0 ml-0">
          <div class="filter-item-date pl-0 ml-0">
            <div class="filter-item-label" style="visibility: hidden;">..</div>
            <button class="button cross-btn ml-2" (click)="clearFilter()"><i class="fa fa-times" aria-hidden="true"></i>
          </button>
          <button id="refresh" (click)="refreshList()" class="button search-btn ml-3">
            {{'' | i18n: 'search'}}
          </button>

        </div>
      </div>
      <div class="col-4 pl-0 ml-0">
        <div class=" pagecount-container mr-0">
          <button id="removePage" (click)="changePage(-1)" class="button button-page"
            [disabled]="this.filter.page == 0"><img alt="" src="assets/images/BMW-previous-144.png" width="20px"
          height="20px"></button>
          <div class="page-text-container"> {{ filter.page + 1 }} </div>
          <button id="addPage" (click)="changePage(1)" class="button button-page"
            [disabled]="this.failedUploadData.pageCount <= this.filter.page+1">
            <img alt="" src="assets/images/BMW-next-144.png" width="20px" height="20px">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th><a (click)="orderBy('exportDate')">{{'' | i18n: 'Date of Export'}}@if (filter.orderBy == 'exportDate') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th><a (click)="orderBy('contractCount')">{{'' | i18n: 'no-of-contracts'}}@if (filter.orderBy == 'contractCount') {
            <img
              src="{{showDirectionImage()}}" alt="" class="sort-img"/>
          }</a></th>
          <th>{{'' | i18n: ''}}</th>
        </tr>
      </thead>
      <tbody>
        @for (failedUpload of failedUploadData.dataList; track failedUpload) {
          <tr >
            <td>{{failedUpload.createddate}}</td>
            <td>{{failedUpload.contractcount}}</td>
            <td>
              <button class="search-btnn" (click)="exportFailedExportAsXLSX(failedUpload.createddate)">{{'' | i18n: 'export'}}</button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>
